import {InquiryMultiField} from "./inquiry_multi_field";

export const InquiryInterestsFieldConfig = {
    baseHtmlClass: 'inquiry_field--inquiry_interests',
    selector: '.inquiry_field--inquiry_interests'
}

export class InquiryInterestsField extends InquiryMultiField {

    static new(InquiryForm) {
        if (!InquiryForm.element) { return null }
        const element = InquiryForm.element.querySelector(InquiryInterestsFieldConfig.selector);
        if (element) { return new InquiryInterestsField(element, InquiryForm) }
    }

    constructor(id_or_element, InquiryForm) {
        super(id_or_element, InquiryForm);
    }

    getInquiryInterestsInputsValues() {
        let values = [];
        // FIXME - Add radio button support…
        this.element.querySelectorAll('input[type=checkbox], input[type=radio]').forEach((element)=>{
            if (element.checked){
                console.log("[InquiryInterestsField] getInquiryInterestsInputsValues() - element", element);
                const v = this.typecastValue(element.getAttribute('title'));
                if (v && v !== '') { values.push(v) }
            }
        });
        return values;
    }

    // Returns the single value as calculated by looking at each of the selector's inputs.
    getInputsValue() {
        const values = this.getInquiryInterestsInputsValues();
        if (values.length < 1) { return null }
        return values;
    }

    typecastValue(value) {
        if (value === '' || value === null) { return null }
        value = String(value);
        return value;
    }

    hasValue() {
        return this.value !== null;
    }

    beforeUpdate() {
        this.errorChecking = true;
        super.beforeUpdate();
    }

    appendErrors() {
        if (!this.hasValue()) { this.errors.push(`At least one ${ this.label } must be selected.`) }
    }

}